import { defineStore } from 'pinia'
import { getProductInfo } from '@/api/discount-membership'
import { ACCOUNT_TYPE } from '@/const'

export const useProductStore = defineStore('product', {
    state: () => ({
        membershipProductInfo: null,
        fleetProductInfo: null,
        dot: '',
    }),
    actions: {
        async fetchProductInfo(type) {
            const res = await getProductInfo(type)
            const desc = res?.description?.[0] || {}
            let content = {}
            try {
                content = desc.content ? JSON.parse(desc.content) : {}
            } catch (e) {
                content = {}
            }
            if (type === ACCOUNT_TYPE.DIAMOND_ANNUAL) {
                this.membershipProductInfo = { ...desc, ...content }
            } else if (type === ACCOUNT_TYPE.FLEET_MONTH) {
                this.fleetProductInfo = { ...desc, ...content }
            }
        },
    },
    persist: true,
})
